import React from "react";
import WrappersManagement from "../../features/wrappersmanagement";

const AssetsWrappersManagementPage = () => <WrappersManagement />

export default AssetsWrappersManagementPage;